"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Help = Help;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("../Link");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Help(_ref) {
  let {
    helpUrl,
    text,
    indent = 'M',
    onClick
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['container'], indent === 'M' && styles['middle_container'], indent === 'L' && styles['left_container']),
    "data-testid": "help"
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(indent === 'M' && styles['middle_padding-wrapper'], indent === 'L' && styles[`left_padding-wrapper--${deviceType}`])
  }, /*#__PURE__*/React.createElement(_Link.Link, {
    href: helpUrl,
    target: "_blank",
    onClick: onClick,
    responsive: true
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['link-content'], styles[`link-content--${deviceType}`])
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "primary_100"
  }, text || 'Служба поддержки')))));
}